import { render, staticRenderFns } from "./SignEditor.vue?vue&type=template&id=06458f05"
import script from "./SignEditor.vue?vue&type=script&lang=js"
export * from "./SignEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports